module.exports = __webpack_public_path__ + "static/media/eyeClose.59547c20.png";